import { render, staticRenderFns } from "./PartnerAdd.vue?vue&type=template&id=4e45045d&scoped=true"
import script from "./PartnerAdd.vue?vue&type=script&lang=js"
export * from "./PartnerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45045d",
  null
  
)

export default component.exports